import DOMPurify from 'dompurify';

// Configure DOMPurify to allow specific tags and attributes for embeds
const config = {
  ALLOWED_TAGS: ['iframe', 'img', 'div', 'a', 'p', 'br', 'span'],
  ALLOWED_ATTR: [
    'src',
    'height',
    'width',
    'frameborder',
    'allowfullscreen',
    'allow',
    'alt',
    'title',
    'class',
    'style',
  ],
  ALLOWED_URI_REGEXP:
    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|xxx):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
};

// Initialize DOMPurify with custom config
DOMPurify.setConfig(config);

export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, config);
};

// Validate if the content is an embed code
export const isValidEmbedCode = (content) => {
  const sanitized = sanitizeHtml(content);
  return (
    sanitized.includes('<iframe') ||
    sanitized.includes('<img') ||
    sanitized.includes('<div class="embed')
  );
};

export const makeEmbedResponsive = (code) => {
  // Create a temporary DOM element to parse the HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = code;

  // Handle iframes
  if (code.includes('<iframe')) {
    const iframe = tempDiv.querySelector('iframe');
    if (iframe) {
      const iframeSrc = iframe.getAttribute('src') || '';
      const iframeTitle = iframe.getAttribute('title') || 'Embedded content';
      const iframeAllow =
        iframe.getAttribute('allow') ||
        'accelerometer; autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; gyroscope; picture-in-picture';

      // Return iframe wrapped in responsive container
      return `<iframe
                  class="w-full h-full border-0"
                  src="${iframeSrc}"
                  title="${iframeTitle}"
                  loading="lazy"
                  allow="${iframeAllow}"
                  allowFullScreen
                ></iframe>`;
    }
  }

  // Handle images
  else if (code.includes('<img')) {
    const img = tempDiv.querySelector('img');
    if (img) {
      // Make image responsive but maintain its aspect ratio
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
      return img.outerHTML;
    }
  }

  // Handle embed divs - check if they need responsiveness
  else if (code.includes('<div class="embed')) {
    // Most embed divs may already be responsive
    // But we can add a wrapper to ensure they behave well
    return `<div style="width: 100%;">${code}</div>`;
  }

  // If we couldn't identify or modify it, return original code
  return code;
};
